import React, { useState } from 'react';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../../shared/components/auth/withAuth';
import { post } from '../../../utils/api/base';
import env from '../../../Env';

const FallbackLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const auth = useAuth();
  const history = useHistory();
  const location = useLocation();
  const passwordReset = location?.state?.passwordReset;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const response = await post(`${env.baseApiUrl}/api/authentication/login`, {
        emailAddress: email,
        password,
      });

      if (response?.data?.success) {
        auth.signin();
        history.replace('/dashboard');
      } else {
        setError('Invalid credentials.');
      }
    } catch (err) {
      if (err?.response?.status === 401) {
        setError('Invalid credentials.');
      } else {
        setError('Login failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <div className="account__head" />
          {passwordReset && (
            <div className="account__btns">
              <span className="text-success">Password reset successfully. Please sign in.</span>
            </div>
          )}
          <form className="form" onSubmit={handleSubmit}>
            <div className="form__form-group">
              <span className="form__form-group-label">Email</span>
              <div className="form__form-group-field">
                <input
                  className="form__field"
                  type="email"
                  name="email"
                  placeholder="admin@llx.com"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                  autoComplete="username"
                />
              </div>
            </div>
            <div className="form__form-group">
              <span className="form__form-group-label">Password</span>
              <div className="form__form-group-field">
                <input
                  className="form__field"
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                  autoComplete="current-password"
                />
              </div>
            </div>
            <div className="form__form-group">
              <Link to="/admin/forgot-password">Forgot password?</Link>
            </div>
            <div className="form__form-group">
              {error && (
              <div className="account__btns">
                <span className="text-danger">{error}</span>
              </div>
              )}
            </div>
            <div className="account__btns">
              <button
                className="account__btn btn btn-primary"
                type="submit"
                disabled={loading}
              >
                {loading ? 'Signing in...' : 'Sign in'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FallbackLogin;
